module.exports = __webpack_public_path__ + "static/media/3_Orient-Template-Left.38f13a12.svg";